import React from 'react'
import {INavNotification} from '@api/user/account/notification/getNotification'
import NavNotificationListItem from '@component/header/GlobalNavigation/NotificationDropdown/NavNotificationListItem'
import {isEmptyArray} from '@util/array'

interface IProps {
    data?: Array<INavNotification>
}

const EarlierNotificationList = ({data}: IProps) => {
    if (isEmptyArray(data)) {
        return <></>
    }
    return (
        <>
            <div className={'mt-[10px]'}>
                {data?.map(list => (
                    <NavNotificationListItem data={list} key={list?._id} />
                ))}
            </div>
        </>
    )
}

export default EarlierNotificationList
